import '../css/index.scss';
import '../css/blog/post.scss';
// Publisher logo referenced by the posts' Organization structured data
import '../assets/logo-black.png';
import Header from '../components/header';

new Header()
